import React, { Component, Fragment } from 'react';
import { inject, observer } from 'mobx-react';
import Modal from '../Modal';
import InventoryHeader from './InventoryHeader';
import { withRouter } from 'react-router-dom';
import Loading from '../Loading';
import moment from 'moment';
import Select from 'react-select';
import { getFromLocalStorage } from '../../services/utils';
import InventoryConstants from './InventoryConstants';

const base = 'inventory-adjustment';
const RESTRICTED_QUICK_STOCK_DEDUCTION_REASONS = InventoryConstants.RESTRICTED_QUICK_STOCK_DEDUCTION_REASONS;

@inject('ComponentStockStore', 'UserStore')
@inject('InventoryStore')
@observer
class InventoryComponentStockUpdate extends Component {
    initialState = {
        showAdjustmentModal: false,
        quantity: {},
        totalQuantity: 0,
        showConfirmationModal: false,
        showBatchHistoryModal: false,
        currentSku: undefined,
        selectedReason: {},
        delta: 0,
        selectedHub: {},
        searchQuery: ''
    };

    state = this.initialState;

    componentDidMount = () => {
        const {
            ComponentStockStore: {
                getStockCountAvailability
            },
            UserStore: {
                position
            }
        } = this.props;
        if (position == 'Territory Manager') {
            this.initData();
        } else {
            getStockCountAvailability(this.hideLoader, this.initData);
        }
    };

    initData = () => {
        const {
            ComponentStockStore: {
                handleGetUnitBatches,
                getAllUnitSkus
            },
        } = this.props;
        handleGetUnitBatches();
        getAllUnitSkus();
    }

    hideLoader = () => {
        const {
            ComponentStockStore
        } = this.props;
        ComponentStockStore.componentStockUpdateLoading = false;
    }

    handleUnselectSku = () => {
        this.setState({ quantity: {}, totalQuantity: 0, currentSku: undefined });
    };

    handleSearchQueryChange = (event) => {
        this.setState({ searchQuery: event.target.value });
    };

    handleShowAdjustmentModal = () => {
        this.setState({ showAdjustmentModal: true});
    };

    handleCloseAdjustmentModal = () => {
        this.setState(this.initialState);
    };

    handleShowConfirmationModal = () => {
        this.setState({ showConfirmationModal: true });
    };

    handleCloseConfirmationModal = () => {
        this.setState({ showConfirmationModal: false });
    };

    handleShowBatchHistoryModal = () => {
        this.setState({ showBatchHistoryModal: true});
    };

    handleCloseBatchHistoryModal = () => {
        this.setState({ showBatchHistoryModal: false});
    };

    handleSetQuantity = (plusMinus, uomQuantities) => {
        if (plusMinus === 'plus') {
            uomQuantities.forEach(({ uom, quantity: innerQuantity }) => {
                this.setState(prevState => ({
                    quantity: { ...prevState.quantity, [uom + innerQuantity]: (prevState.quantity[uom + innerQuantity] || 0) + 1 },
                    delta: prevState.delta + innerQuantity,
                    totalQuantity: prevState.totalQuantity + innerQuantity
                }));
            });
        } else {
            uomQuantities.forEach(({ uom, quantity: innerQuantity }) => {
                this.setState(prevState => ({
                    quantity: { ...prevState.quantity, [uom + innerQuantity]: (prevState.quantity[uom + innerQuantity] || 0) - 1 },
                    delta: prevState.delta - innerQuantity,
                    totalQuantity: prevState.totalQuantity - innerQuantity
                }));
            });
        }
    };

    handleSetSKUReason = (reason) => {
        this.setState({selectedReason: reason});
    };

    handleSetHub = (hubCode) => {
        this.setState({selectedHub: hubCode});
    };

    handleCheckRequest = (showConfirmationModal, noChange) => {
        if (noChange) {
            return;
        }
        if (showConfirmationModal) {
            this.handleShowConfirmationModal();
        } else {
            this.handleSendRequest();
        }
    };

    canDeductWithRestrictedReason = () => {
        const {
            UserStore
        } = this.props;
        return UserStore.canUseManagerStockReason();
    };

    handleSendRequest = () => {
        const { totalQuantity, currentSku, selectedReason, delta, selectedHub} = this.state;
        const {
            ComponentStockStore: { handleUpdateUnitBatch },
            UserStore
        } = this.props;

        const restrictedReasons = RESTRICTED_QUICK_STOCK_DEDUCTION_REASONS;
        if (restrictedReasons.includes(selectedReason.value) && delta < 0 && !this.canDeductWithRestrictedReason()) {
            UserStore.message = "Only Business Managers or Territory Managers can deduct stock with reason: " + selectedReason.label + ". Please ask them for help.";
            return;
        }

        let request = {
            unitSku: currentSku,
            quantity: totalQuantity,
            reason: selectedReason.value,
            delta: delta,
            destinationhubCode: selectedHub.value
        };

        handleUpdateUnitBatch(request);
        this.setState(this.initialState);
    };

    handleSetCurrentSku = (sku, batch, unitBatchesHistory) => {
        let batchUpdateHistory =
            unitBatchesHistory
                .filter(record => record.unit_sku === sku)
                .map(record => ({
                    delta: record.delta,
                    quantity: record.quantity,
                    initiator_username: record.initiator_username,
                    reason: record.reason,
                    updated_at: record.updated_at
                }));
        this.setState({
            currentSku: sku,
            totalQuantity: batch.unsold + batch.pre_order_quantity,
            batchUpdateHistory: batchUpdateHistory
        });
    };

    getBaseUom = (unitSku) => {
        for (const packaging of unitSku.packaging) {
            if (packaging.specs.length == 1) {
                return packaging.specs[0].outer_unit_of_measurement;
            }
        }
        return "units";
    };

    getAllUom = (unitSku) => {
        let specs = [];
        if (unitSku.packaging.length) {
            unitSku.packaging[0].specs.forEach((spec) => {
                if (!spec.inner_quantity || spec.inner_quantity == 1) {
                    specs.push(spec)
                }
            })
        }
        for (const packaging of unitSku.packaging) {
            packaging.specs.forEach((spec) => {
                if (spec.inner_quantity && spec.inner_quantity > 1) {
                    specs.push(spec)
                }
            })
        }
        return specs;
    }

    render() {
        const {
            showAdjustmentModal,
            quantity,
            totalQuantity,
            showConfirmationModal,
            currentSku,
            showBatchHistoryModal,
            searchQuery
        } = this.state;
        const {
            InventoryStore: {
                componentListForMenuItem,
                reasonsToShowInDropdown,
                selectedReason,
                selectedHub
            },
            ComponentStockStore: {
                unitBatches,
                componentStockUpdateLoading,
                unitBatchesHistory,
                allUnitSkus
            },
            fromMealUpdateScreen
        } = this.props;
        const hubs = getFromLocalStorage('hubsList');
        let sortedUnitBatches = unitBatches.sort((a,b) => a.unit_sku > b.unit_sku ? 1 : -1)
        let unitSkusToUnsold = {};
        for (const batch of sortedUnitBatches) {
            if (!unitSkusToUnsold[batch.unit_sku]) {
                unitSkusToUnsold[batch.unit_sku] =
                    {
                        name: batch.unit_name,
                        unsold: batch.quantity,
                        pre_order_quantity: batch.pre_order_quantity
                    };
            } else {
                unitSkusToUnsold[batch.unit_sku] =
                    {
                        name: batch.unit_name,
                        unsold: unitSkusToUnsold[batch.unit_sku].unsold + batch.quantity,
                        pre_order_quantity: unitSkusToUnsold[batch.unit_sku].pre_order_quantity + batch.pre_order_quantity
                    };
            }
        }
        let componentsForMenuItem = {};
        let parentComponentsForMenuItem = {};
        for (let componentForMenuItem of componentListForMenuItem){
            if (unitSkusToUnsold[componentForMenuItem.unit_sku]){
                componentsForMenuItem[componentForMenuItem.unit_sku] = {
                    name : unitSkusToUnsold[componentForMenuItem.unit_sku].name,
                    unsold: unitSkusToUnsold[componentForMenuItem.unit_sku].unsold,
                    pre_order_quantity: unitSkusToUnsold[componentForMenuItem.unit_sku].pre_order_quantity,
                    is_mandatory: componentForMenuItem.mandatory,
                    quantity_per_meal: componentForMenuItem.quantity
                }

                if (componentForMenuItem.sub_component) {
                    if (unitSkusToUnsold[componentForMenuItem.parent_component_sku]) {
                        parentComponentsForMenuItem[componentForMenuItem.parent_component_sku] = {
                            name : unitSkusToUnsold[componentForMenuItem.parent_component_sku].name,
                            unsold: unitSkusToUnsold[componentForMenuItem.parent_component_sku].unsold,
                            pre_order_quantity: unitSkusToUnsold[componentForMenuItem.parent_component_sku].pre_order_quantity,
                            breakdown_quantity: componentForMenuItem.breakdown_quantity
                        }
                    } else {
                        parentComponentsForMenuItem[componentForMenuItem.parent_component_sku] = {
                            unsold: 0,
                            pre_order_quantity: 0,
                            breakdown_quantity: componentForMenuItem.breakdown_quantity
                        }
                    }
                }
            }
        }

        for (const unitSku of allUnitSkus){
            if (unitSkusToUnsold[unitSku.sku]){
                unitSkusToUnsold[unitSku.sku].name = unitSku.name;
                unitSkusToUnsold[unitSku.sku].packaging = this.getAllUom(unitSku);
                unitSkusToUnsold[unitSku.sku].base_uom = this.getBaseUom(unitSku);
            }
        }

        const normalizedSearchQuery = searchQuery.trim().toLowerCase();
        const matchesSearch = (sku, item = {}) => {
            if (!normalizedSearchQuery) {
                return true;
            }

            return [
                sku,
                item.name,
                item.base_uom,
                item.unsold,
                item.quantity_per_meal,
                item.breakdown_quantity
            ]
                .filter((value) => value !== undefined && value !== null)
                .join(' ')
                .toLowerCase()
                .includes(normalizedSearchQuery);
        };
        const filteredComponentsForMenuItemSkus = Object.keys(componentsForMenuItem)
            .filter((sku) => matchesSearch(sku, componentsForMenuItem[sku]));
        const filteredParentComponentsForMenuItemSkus = Object.keys(parentComponentsForMenuItem)
            .filter((sku) => matchesSearch(sku, parentComponentsForMenuItem[sku]));
        const filteredUnitSkus = Object.keys(unitSkusToUnsold)
            .filter((sku) => matchesSearch(sku, unitSkusToUnsold[sku]));

        if (componentStockUpdateLoading) {
            return <Loading />
        }

        if (fromMealUpdateScreen === true && componentListForMenuItem.length === 0) {
            return null;
        }

        if (!currentSku && fromMealUpdateScreen && componentListForMenuItem.length > 0){
            return (
                <Fragment>
                    <div className={`secondary-header__wrapper bg--white`} style={{position:'sticky', top: 0}}>
                        <div className={`secondary-header`}>
                            <div className="display--flex justify--center flex-align-items-center pll prl pts pbs">
                                <span className="fs--medium-medium-large">Components</span>
                            </div>
                        </div>
                    </div>
                    <div className={`${base}__search`}>
                        <input
                            className={`${base}__search-input`}
                            type="search"
                            value={searchQuery}
                            onChange={this.handleSearchQueryChange}
                            placeholder="Search component SKU or name"
                        />
                    </div>
                    <div className='pm'  style={{ maxWidth: '1000px' }}>
                        <div
                            className={`${base}__sku_letter_top_row`}
                        >
                            <h3 className='text--left fs--medium-large text--bolder'> Component SKU</h3>
                            <h2 className='fs--medium-medium-large text--bolder'>
                                Name
                            </h2>
                            <h2 className='fs--medium-medium-large text--bolder'>
                                Unsold Stock
                            </h2>
                            <h2 className='fs--medium-medium-large text--bolder'>
                                Is Mandatory
                            </h2>
                            <h2 className='fs--medium-medium-large text--bolder'>
                                Quantity Per Meal
                            </h2>
                        </div>
                        <div className={`${base}__skus_of_one_sku_letter`}>
                            {filteredComponentsForMenuItemSkus.map((sku) => (
                                <div key={sku} className={`${base}__one_sku_row`}>
                                    <div
                                        className={`${base}__drawer_button selected`}
                                        style={{ flex: '50%' }}
                                        onClick={() => this.handleSetCurrentSku(sku, componentsForMenuItem[sku], unitBatchesHistory)}
                                    >
                                        {sku}
                                    </div>
                                    <div
                                        className='text--bold fs--medium'
                                        style={{ flex: '50%', fontSize: 'small' }}
                                    >{componentsForMenuItem[sku].name}</div>
                                    <div
                                        className='text--bold fs--medium'
                                        style={{ flex: '50%' }}
                                    >{componentsForMenuItem[sku].unsold}</div>
                                    <div
                                        className='text--bold fs--medium'
                                        style={{ flex: '50%' }}
                                    >{componentsForMenuItem[sku].is_mandatory ? 'Yes' : 'No'}</div>

                                    <div
                                        className='text--bold fs--medium'
                                        style={{ flex: '50%' }}
                                    >{componentsForMenuItem[sku].quantity_per_meal}</div>
                                </div>
                            ))}
                            {filteredComponentsForMenuItemSkus.length === 0 && (
                                <div className={`${base}__empty-results`}>
                                    No component SKUs found.
                                </div>
                            )}
                    </div>
                    </div>

                    <div className={`secondary-header__wrapper bg--white`} style={{position:'sticky', top: 0}}>
                        <div className={`secondary-header`}>
                            <div className="display--flex justify--center flex-align-items-center pll prl pts pbs">
                                <span className="fs--medium-medium-large">Unopened Packets</span>
                            </div>
                        </div>
                    </div>
                    <div className='pm'  style={{ maxWidth: '1000px' }}>
                        <div
                            className={`${base}__sku_letter_top_row`}
                        >
                            <h3 className='text--left fs--medium-large text--bolder'> Component SKU</h3>
                            <h2 className='fs--medium-medium-large text--bolder'>
                                Name
                            </h2>
                            <h2 className='fs--medium-medium-large text--bolder'>
                                Unsold Stock
                            </h2>
                            <h2 className='fs--medium-medium-large text--bolder'>
                                Quantity Per Unit
                            </h2>
                        </div>
                        <div className={`${base}__skus_of_one_sku_letter`}>
                            {filteredParentComponentsForMenuItemSkus.map((sku) => (
                                <div key={sku} className={`${base}__one_sku_row`}>
                                    <div
                                        className={`${base}__drawer_button selected`}
                                        style={{ flex: '50%' }}
                                        onClick={() => this.handleSetCurrentSku(sku, parentComponentsForMenuItem[sku], unitBatchesHistory)}
                                    >
                                        {sku}
                                    </div>
                                    <div
                                        className='text--bold fs--medium'
                                        style={{ flex: '50%', fontSize: 'small' }}
                                    >{parentComponentsForMenuItem[sku].name}</div>
                                    <div
                                        className='text--bold fs--medium'
                                        style={{ flex: '50%' }}
                                    >{parentComponentsForMenuItem[sku].unsold}</div>
                                    <div
                                        className='text--bold fs--medium'
                                        style={{ flex: '50%', fontSize: 'small' }}
                                    >{parentComponentsForMenuItem[sku].breakdown_quantity}</div>
                                </div>
                            ))}
                            {filteredParentComponentsForMenuItemSkus.length === 0 && (
                                <div className={`${base}__empty-results`}>
                                    No unopened packets found.
                                </div>
                            )}
                        </div>
                    </div>
                </Fragment>
            );
        }

        if (!currentSku) {
            return (
                <Fragment>
                    <InventoryHeader title='Choose SKU to update' />
                    <div className={`${base}__component-sku-picker pm`} style={{ maxWidth: '1000px' }}>
                        <div className={`${base}__search`}>
                            <input
                                className={`${base}__search-input`}
                                type="search"
                                value={searchQuery}
                                onChange={this.handleSearchQueryChange}
                                placeholder="Search SKU or name"
                            />
                        </div>
                        <div
                            className={`${base}__sku_letter_top_row ${base}__component-sku-picker-header`}
                        >
                            <h3 className='text--left fs--medium-large text--bolder'>SKU</h3>
                            <h2 className='fs--medium-medium-large text--bolder'>
                                Name
                            </h2>
                            <h2 className='fs--medium-medium-large text--bolder'>
                                Base UOM
                            </h2>
                            {/* <h2 className='fs--medium-medium-large text--bolder'>
                                Unsold Stock
                            </h2> */}
                        </div>
                        <div className={`${base}__skus_of_one_sku_letter`}>
                            {filteredUnitSkus.map((sku) => (
                                <div key={sku} className={`${base}__one_sku_row ${base}__component-sku-picker-row`}>
                                    <div
                                        className={`${base}__drawer_button ${base}__component-sku-picker-button selected`}
                                        style={{ flex: '50%' }}
                                        onClick={() => this.handleSetCurrentSku(sku, unitSkusToUnsold[sku], unitBatchesHistory)}
                                    >
                                        {sku}
                                    </div>
                                    <div
                                        className={`${base}__component-sku-picker-name text--bold fs--medium`}
                                        style={{ flex: '50%', fontSize: 'small' }}
                                    >{unitSkusToUnsold[sku].name}</div>
                                    <div
                                        className={`${base}__component-sku-picker-uom text--bold fs--medium`}
                                        style={{ flex: '50%', fontSize: 'small' }}
                                    >{unitSkusToUnsold[sku].base_uom}</div>
                                    {/* <div
                                        className='text--bold fs--medium'
                                        style={{ flex: '50%' }}
                                    >{unitSkusToUnsold[sku].unsold}</div> */}
                                </div>
                            ))}
                            {filteredUnitSkus.length === 0 && (
                                <div className={`${base}__empty-results`}>
                                    No SKUs found.
                                </div>
                            )}
                        </div>
                    </div>
                    {Object.keys(unitSkusToUnsold) == 0 &&
                        <div className='ml'>This screen is disabled. This will be re-enabled before opening hours tomorrow</div>
                    }
                </Fragment>
            );
        }

        return (
            <Fragment>
                <InventoryHeader
                    title={`${
                        currentSku + ' : ' + unitSkusToUnsold[currentSku].name
                    } Quick Stock Update`}
                    onClickBackLink={this.handleUnselectSku}
                />
                {<Fragment>
                            <div
                                className={`pl row col-lg-12 ${base}__component-stock-detail-summary`}
                            >
                                <div className={`text--left col-lg-6 col-sm-12 col-xs-12 ${base}__component-stock-detail-copy`}>
                                    <p className='text--bolder fs--medium-large'>
                                        {currentSku + ' : ' + unitSkusToUnsold[currentSku].name}
                                    </p>
                                    <p className='fs--medium-large'>{`${unitSkusToUnsold[currentSku].unsold} unsold`}</p>
                                    <p className='fs--medium-large'>{`${unitSkusToUnsold[currentSku].unsold + unitSkusToUnsold[currentSku].pre_order_quantity} ${unitSkusToUnsold[currentSku].base_uom} in the Hub`}</p>
                                    {unitSkusToUnsold[currentSku].pre_order_quantity > 0 &&
                                        <p className='fs--medium-large'>{`${unitSkusToUnsold[currentSku].pre_order_quantity} Pre-orders`}</p>}
                                </div>
                                <div className={`col-lg-6 text--right col-sm-12 col-xs-12 ${base}__component-stock-detail-actions`}>
                                    <div className={`col-lg-6 col-sm-6 col-xs-6 ${base}__component-stock-detail-action`}>
                                        <button
                                            className='btn btn-primary mrm'
                                            onClick={() =>
                                                this.handleShowAdjustmentModal()
                                            }
                                        >
                                            Update
                                        </button>
                                    </div>
                                    <div className={`col-lg-6 col-sm-6 col-xs-6 ${base}__component-stock-detail-action`}>
                                        <button
                                            className='btn btn-primary mrm'
                                            onClick={() =>
                                                this.handleShowBatchHistoryModal()
                                            }
                                        >
                                            History
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </Fragment>
                    }
                {showAdjustmentModal && (
                    <Modal className={`${base}__component-stock-adjustment-modal`} width={'600px'}>
                        <h3 className='text--boldest fs--medium-medium-large'>
                            {currentSku + ' : ' + unitSkusToUnsold[currentSku].name}
                        </h3>
                        <p className='mbm'>Add or take</p>
                        {unitSkusToUnsold[currentSku].packaging.map(p => (
                            <div className='quantity-selector' key ={p.outer_unit_of_measurement}>
                                <button
                                    className={`quantity-selector-button`}
                                    disabled={
                                        totalQuantity == 0
                                    }
                                    onClick={() => this.handleSetQuantity('minus', [{uom : p.outer_unit_of_measurement, quantity : p.inner_quantity ? p.inner_quantity : 1}])}
                                >
                                    <svg className='icon'>
                                        <use xlinkHref={`#icon-minus`} />
                                    </svg>
                                </button>
                                <div className='fs--medium-large width--175px text--center'>
                                    {`${totalQuantity - unitSkusToUnsold[currentSku].unsold - unitSkusToUnsold[currentSku].pre_order_quantity > 0 ? '+' : ''}
                                    ${p.inner_quantity ? 
                                        (quantity[p.outer_unit_of_measurement + p.inner_quantity] ? quantity[p.outer_unit_of_measurement + p.inner_quantity] : 0) :
                                          (quantity[p.outer_unit_of_measurement + 1] ? quantity[p.outer_unit_of_measurement + 1] : 0)} 
                                    ${p.outer_unit_of_measurement}`} <br/>
                                    {`${p.inner_quantity ? ("(" + p.inner_quantity + " " + unitSkusToUnsold[currentSku].base_uom + ")") : ''}`
                                }</div>
                                <button
                                    className='quantity-selector-button'
                                    onClick={() => this.handleSetQuantity('plus', [{uom : p.outer_unit_of_measurement, quantity : p.inner_quantity ? p.inner_quantity : 1}])}
                                >
                                    <svg className='icon'>
                                        <use xlinkHref={`#icon-plus`} />
                                    </svg>
                                </button>
                            </div>
                        ))}
                        <div className={`${base}__component-stock-adjustment-field row`}>
                            <div className={`${base}__component-stock-adjustment-label col-xs-2`}>Reason :</div>
                            <div className={`${base}__component-stock-adjustment-control col-xs-10`}>
                                <Select
                                    className='fs--medium-medium-large width--50 center--horizontal'
                                    value={selectedReason}
                                    required
                                    options={reasonsToShowInDropdown}
                                    name='reasons'
                                    onChange={this.handleSetSKUReason}
                                    placeholder='Select Reason'
                                    menuPortalTarget={document.body}
                                    styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                />
                            </div>
                        </div>
                        {this.state.selectedReason.value === 'INTER_OUTLET_TRANSFER' &&
                            <div className={`${base}__component-stock-adjustment-field row`}>
                                <div className={`${base}__component-stock-adjustment-label col-xs-2`}>Destination Hub :</div>
                                <div className={`${base}__component-stock-adjustment-control col-xs-10`}>
                                    <Select
                                        className='fs--medium-medium-large width--50 center--horizontal'
                                        value={selectedHub}
                                        required
                                        options={hubs}
                                        name='reasons'
                                        onChange={this.handleSetHub}
                                        placeholder='Select Hub'
                                        menuPortalTarget={document.body}
                                        styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                    />
                                </div>
                            </div>
                        }
                        <div className={`mtm ${base}__component-stock-adjustment-total`}>
                            <div className={`${base}__component-stock-adjustment-total-label`}>
                                New total Stock:
                            </div>
                            <div className={`text--bolder ${base}__component-stock-adjustment-total-value`}>
                                {`${
                                    totalQuantity
                                } ${unitSkusToUnsold[currentSku].base_uom}`}
                            </div>
                        </div>
                        {RESTRICTED_QUICK_STOCK_DEDUCTION_REASONS.includes(this.state.selectedReason.value) &&
                         !this.canDeductWithRestrictedReason() && (
                            <div style={{color: 'red', marginTop: '10px', textAlign: 'center'}}>
                                Only Business Managers or Territory Managers can deduct stock with this reason. Please ask them for help.
                            </div>
                        )}
                        <div className='display--flex justify--space-around'>
                            <button
                                className='btn btn-secondary ms flex-1'
                                onClick={this.handleCloseAdjustmentModal}
                            >
                                Cancel
                            </button>
                            <button
                                className='btn btn-primary ms flex-1'
                                disabled={
                                    this.state.selectedReason.value == null ||
                                    (RESTRICTED_QUICK_STOCK_DEDUCTION_REASONS.includes(this.state.selectedReason.value) &&
                                     !this.canDeductWithRestrictedReason())
                                }
                                onClick={() => this.handleCheckRequest(totalQuantity < unitSkusToUnsold[currentSku].pre_order_quantity, totalQuantity == unitSkusToUnsold[currentSku].unsold + unitSkusToUnsold[currentSku].pre_order_quantity)}
                            >
                                Confirm
                            </button>
                        </div>
                    </Modal>
                )}
                {showConfirmationModal && (
                    <Modal>
                        <div className='mbm fs--medium'>
                            You are removing stock that has already been sold.
                            CS will be notified to cancel the orders. This will
                            impact your HUB PERFORMANCE KPI. Are you sure?
                        </div>
                        <div className='display--flex justify--space-around'>
                            <button
                                className='btn btn-secondary ms flex-1'
                                onClick={this.handleCloseConfirmationModal}
                            >
                                Go Back
                            </button>
                            <button
                                className='btn btn-primary ms flex-1'
                                onClick={() => this.handleSendRequest()}
                            >
                                Proceed
                            </button>
                        </div>
                    </Modal>
                )}
                {showBatchHistoryModal && (
                    <Modal>
                        <div className="mbm text--center">
                            <div className="history-modal">
                                <span>History</span>
                                <table className="history-table">
                                    <thead>
                                    <tr>
                                        <th>Date</th>
                                        <th>New Quantity</th>
                                        <th>Delta</th>
                                        <th>Reason</th>
                                        <th>User</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {this.state.batchUpdateHistory.map((history)=>
                                            <tr key ={history.updated_at}>
                                                <td>{moment(history.updated_at, 'x').format('DD/MM/YYYY HH:mm A')}</td>
                                                <td>{history.quantity}</td>
                                                <td>{history.delta}</td>
                                                <td>{history.reason}</td>
                                                <td>{history.initiator_username}</td>
                                            </tr>)}
                                    </tbody>
                                </table>
                            </div>
                            <button
                                className="btn flex-1"
                                onClick={this.handleCloseBatchHistoryModal}
                            >
                                Close
                            </button>
                        </div>
                    </Modal>
                )}
            </Fragment>
        );
    }
}

export default withRouter(InventoryComponentStockUpdate);
